import React from 'react';
import {
    Controller,
    Control,
    FieldValues,
    RegisterOptions,
    UseFormRegister,
} from 'react-hook-form';

export interface RadioOption {
    label: string;
    value: string;
    default?: boolean;
}

export interface RadioButtonGroupProps {
    name: string;
    label?: string;
    options: RadioOption[];
    className?: string;
    register?: UseFormRegister<FieldValues>;
    rules?: RegisterOptions;
    control?: Control<FieldValues>;
    error?: string;
    [key: string]: any;
    direction?: string;
    onChange?: any;
    radioName?: string;
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
    name,
    label,
    options,
    className,
    register,
    rules,
    control,
    error,
    direction,
    onChange,
    radioName,
    ...rest
}) => {
    return (
        <div className={className ? className : "flex flex-col gap-[6px]"}>
            {label && (
                <label className="flex justify-start items-start text-sm text-neutral-25 mb-1">
                    {label}
                    {rules?.required && <span className="text-error-400 ml-1">*</span>}
                </label>
            )}

            {control ? (
                <Controller
                    name={name}
                    control={control}
                    rules={rules}
                    render={({ field }) => (
                        <div className={`flex flex-${direction ? direction : 'col'} gap-[8px]`}>
                            {options.map((option) => (
                                <label key={option.value} className="flex items-center gap-2 text-neutral-25">
                                    <input
                                        type="radio"
                                        value={option.value}
                                        name={radioName}
                                        checked={option?.default ? true : field.value === option.value}
                                        onChange={(e) => {
                                            field?.onChange(e.target.value);
                                            onChange && onChange(e?.target?.value);
                                        }}
                                        className="accent-primary-500"
                                    />
                                    {option.label}
                                </label>
                            ))}
                        </div>
                    )}
                />
            ) : register ? (
                <div className={`flex flex-${direction ? direction : 'col'} gap-[8px]`}>
                    {options.map((option) => (
                        <label key={option.value} className="flex items-center gap-2 text-neutral-25">
                            <input
                                type="radio"
                                value={option.value}
                                {...register(name, rules)}
                                className="accent-primary-500"
                                onChange={(e) => {
                                    onChange && onChange(e?.target?.value);
                                }}
                                {...rest}
                            />
                            {option.label}
                        </label>
                    ))}
                </div>
            ) : (
                <div className={`flex flex-${direction ? direction : 'col'} gap-[8px]`}>
                    {options.map((option) => (
                        <label key={option.value} className="flex items-center gap-2 text-neutral-25">
                            <input
                                type="radio"
                                name={name}
                                value={option.value}
                                className="accent-primary-500"
                                onChange={(e) => {
                                    onChange && onChange(e?.target?.value);
                                }}
                                {...rest}
                            />
                            {option.label}
                        </label>
                    ))}
                </div>
            )}

            {error && <span style={{ color: 'red' }}>{error}</span>}
        </div>
    );
};

export default RadioButtonGroup;
